import Vue from 'vue'
import VueX from 'vuex'

Vue.use(VueX)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  render: h => h(require('./App'))
})



// WEBPACK FOOTER //
// ./src/main.js